import {ProfileInfoComponent} from "./profile-info.component";

export default ProfileInfoComponent